import React from "react";
import {Headings} from "../../elements/Headings/Headings";
import Image from "../../elements/Image/Image";
import {Paragraph} from "../../elements/Paragraph/Paragraph";
import {Button} from "../../elements/Button/Button";

export const BlogArticleTile = ({ props }) => {

    return (
        <div className={'blog-article-tile flex flex-col gap-2'}>
            <Image imageUrl={props.article.image}/>

            <div className={'featured_blog__details flex gap-2'}>
                <span className={'tag'}>CATEGORY</span>
                <span className={'read_time text-xs'}>5 min read</span>
            </div>

            <Headings text={props.article.title} type={"h3"}/>

            <Paragraph text={'With more and more releases of iPhones coming out, more phones have started...'}/>
            <Button type={'button-secondary'} link={props.article.url} label={'Read more'} onClick={undefined}/>
        </div>
    )
}

